export default class UserAgent {
  constructor() {
    this.$html = $('html')
  }

  init() {
    this.removeNoscript()
    this.setPositonDots()
    this.handleOneTrustPreferenceClick()
    $('.dot-block').addClass('set-done')
    $(window).on('resize', () => {
      this.setPositonDots()
    })
  }

  removeNoscript() {
    $('#notify').remove()
  }

  getTranslateY(element) {
    const style = window.getComputedStyle(element);
    const transform = style.transform || style.webkitTransform || style.mozTransform;
    const matrix = transform.match(/^matrix3d\((.+)\)$/);
    if (matrix) { return parseFloat(matrix[1].split(', ')[13]) }
    const matrix2d = transform.match(/^matrix\((.+)\)$/);
    return matrix2d ? parseFloat(matrix2d[1].split(', ')[5]) : 0;
  }

  setPositonDots() {
    $('.position-dot').each((_i, e) => {
      const $module = $(e).closest('.block-section')
      const $dot = $module.find('.dot-block')
      if ($dot.length === 0) { return }
      const $prAnis = $(e).parents('.anima-bottom')
      let translateY = 0
      if ($prAnis.length) {
        $prAnis.each((_ii, ee) => {
          translateY += this.getTranslateY(ee)
        })
      }
      const topPostion = $(e).offset().top - $module.offset().top + (parseInt($(e).css('line-height'), 10) / 2) - translateY
      $dot.css('top', topPostion - $dot.height() / 2)
    })
  }

  handleOneTrustPreferenceClick() {
    $('.ot-sdk-show-settings-custom').on('click', (e) => {
      e.preventDefault()
      if (window.OneTrust && typeof window.OneTrust.ToggleInfoDisplay === 'function') {
        window.OneTrust.ToggleInfoDisplay()
      } else if (window.OneTrust && typeof window.OneTrust.ShowPreferenceCenterUI === 'function') {
        window.OneTrust.ShowPreferenceCenterUI()
      } else {
        console.warn('OneTrust is not available. Please check if the script is loaded correctly.')
      }
    });
  }

}

new UserAgent().init()
